.flyout {
  position: fixed !important;
  z-index: 1000; /* this must be higher than the modal body z-index */
  pointer-events: none;
  visibility: hidden;
}

.flyout::-webkit-scrollbar, .flyout::-webkit-scrollbar-track {
  background: transparent;
}

.visible {
  visibility: visible;
  pointer-events: all;
}

.locator {
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  pointer-events: none !important;
  margin: 0 !important;
  padding: 0 !important;
}
